import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./bumble2.css"
import img from "./pics/bumble2.jpeg";
const Bumble = () => {
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoars" />
      <div className="blue-bg">
     
      
        {/* <h2 className="titleart">Modern Vanvas</h2> */}
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/shortstories" target='_blank' data-wpel-link="internal">Short Stories</a></h4>
		<h1 class="entry-title">Love On A Bumble Lane</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">14.09.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

  <h2 class="entry-title">Part-02</h2>

  <h2 className="titles1-4"> Present(Almost 1 year ahead)<br/>
8 p.m 9th September 2023
</h2>
        <div className="description1-2">
        <p>Today has been incredibly exhausting with internals, my internship, assignments, and lab exams all piling up at once. I just want to collapse into my bed and sleep, but I have to head to the airport tonight. Ayush promised to pick me up at 10 p.m., so I need to quickly take a shower and have dinner before then.</p><br/>

<p>I've asked Ayush several times to pick up his brother, Dev, alone, but he insisted I come along. Apparently, they don't get along well, which might explain why he hasn't talked much about Dev, aside from the fact that he's doing his MBA in London.</p><br/>

<p>I decide to take a long, relaxing, hot shower to unwind. As I step out and start dressing in a hoodie and jeans, I notice a light in the hallway. It might be Aisha, my roommate, returning from her jog.</p><br/>

<p>"What should we do for dinner?" she asks.</p><br/>

<p>"I'm too exhausted to prepare anything. Let's just order something. I'm craving burgers," I reply.</p><br/>

<p>"Okay, sounds good. You order," she responds.</p><br/>

<p>I place the order and then inform Aisha about our airport plans tonight.</p><br/>

<p>She asks, "Don't you think it's obvious that Ayush likes you?"</p><br/>

<p>I'm taken aback. "What are you talking about? He's an amazing friend, that's all."</p><br/>

<p>"He asked you out last year, Sunaina. Don't be oblivious. When you said no, he thought the only way to be close to you was by being friends. Why are you being so naive?"</p><br/>

<p>Yes, Ayush did ask me out about a month after we met, but when I declined, he didn't seem upset. We both moved past it and became great friends. We've never revisited that conversation. We casually flirt with each other, but it's nothing more than that.</p><br/>

<p>I reply firmly, "No, there's nothing like what you're thinking. Drop it. He's one of my best friends, and I don't want to lose him. End of story."

She drops the topic, and we continue with our dinner, memories of how I met Ayush floods my mind. Little did I know the day I met him, we would be such great friends.</p><br/>
</div>
<h2 className="titles1-4">
 1 year ago(Almost)<br/>
10:00 p.m 8th November, 2022
   </h2>   
   <div className="description1-2">
   <p>In an attempt to confirm his presence, I hesitantly poke him, and to my surprise, he's real. He's here, staring at me…

Why is Daksh here?</p><br/>

<p>“Hey, are you fine?” he asks me. I don't know what to say. There is a massive lump in my throat, the sadness, the alcohol, and the shock of Daksh being here all at once are too much.

Wait, it’s not Daksh. Though this guy is tall and built like him, it’s not him. Maybe I’m overthinking about Daksh, and now I’m seeing him everywhere.</p><br/>

<p>“Heyy?” The guy asks me again, breaking my momentary trance.</p><br/>

<p>I manage to stammer out, “I'm fine. I came here with my friends, but I needed some fresh air, so I stepped out.” I mentally berate myself for confiding in a stranger.</p><br/>

<p>He takes a seat beside me, and for a moment, I consider walking away. He could be a creep or just looking for a one-night stand. An awkward silence hangs between us. During this time, I discreetly assess his attire. He's dressed sharply in a black shirt from Peter England, jeans, and a pair of Louis Vuitton shoes. He looks too put-together to be a creep, but appearances can be deceiving. Maybe he's just looking for a casual hookup.</p><br/>

<p>He introduces himself as Ayush, a second-year BBA student at Christ University, hailing from Bangalore and, like me, a Kannadiga. We're likely around the same age. I introduce myself in return.

As the conversation progresses, I ask the usual questions about his major, where he lives, and more. He reciprocates, and we talk for nearly an hour.

Then we walk around for a bit and grab ice cream at Milano.</p><br/>

<p>It's now around 1 a.m., I ask him, “So, what brings you here?”

He responds, “Honestly, I'm not feeling the party vibe either. Want to get out of here?”</p><br/>

<p>I nod, though instantly, I'm filled with a sense of apprehension.

I don't know him at all, and my mind races with thoughts of the dangers that real life can hold. It's not a movie, and there are indeed monsters out there. Images from the Indian Predator flash before my eyes, a grim reminder of the harsh realities. Going away with a stranger, especially at this hour, seems like a risky move.

He says, “Stay here, I’ll get my bike,” and then he leaves.</p><br/>

<p>I know I shouldn't be doing this, but the allure of escaping reality for a night and having some fun is hard to resist. Deep down, I have a hunch that this might not be as dangerous as it seems. I choose to trust my intuition, even though it's a risky decision. Without hesitation, I send a quick text to Aisha, letting her know that I won't be coming home tonight. I anticipate her anger for informing her so late and for abruptly leaving the party.</p><br/>

<p>Soon, a black Himalayan bike pulls up in front of me. I'm taken aback. How can he have my favorite bike, out of all the bikes in the world? He hands me a helmet, and I put it on before hopping on the back of the bike.

With a sense of uncertainty and excitement, I ask, “Where are we going?”

“You'll see,” he replies cryptically.

From that point on, we don't exchange many words as the bike roars to life and we set off into the night.</p><br/>

</div>
   <h2 className="titles1-4">
   Present<br/>
10:30 p.m 9th September 2023
   </h2>
   <div className="description1-2">
   <p>This guy knows my strong dislike for tardiness, yet he remains unchanged, stubbornly ignoring my repeated pleas for punctuality.

Today, he showed up 30 minutes late with his brother's Creta, which he occasionally uses since his brother is not around.</p><br/>

<p>I can't help but scold him once again about the importance of being on time. It's a lecture I've delivered countless times over the past eight months or so, but it seems to fall on deaf ears.

I finally ask him about his strained relationship with his brother.</p><br/>

<p>He opens up, saying “I'm sometimes insecure around him. He effortlessly excels in everything he sets his mind to. A few years ago, he started martial arts, and he's become exceptionally skilled at it. I acknowledge that his success is a result of his hard work and dedication. I admit that I'm lazier and less committed than him, but deep down, I can't help but feel a twinge of jealousy. It's one of the reasons I prefer to keep my distance. We used to be inseparable, but as time passed, we naturally drifted apart.”</p><br/>

<p>I listen in silence, contemplating the complexities of male psychology. My thoughts wander back to what Aisha mentioned earlier today. Ayush is undoubtedly a great guy, but he's just not my type. I've never felt a romantic attraction to him, not even in the beginning. As for the idea that he might still have feelings for me, I'm unsure how to handle it. I genuinely hope it's not true because good, solid friendships are rare, and I'm determined not to lose ours. We have the best time together, and I wouldn't trade that for anything.</p><br/>
</div>  
<h2 className="titles1-4">
1 year ago<br/>
1:30 a.m 8th November 2022</h2>
   <div className="description1-2">     
   <p>We are now on the highway. I have decided to not think about the fact that he can be dangerous. I ask him, "Why Himalayan?" Our love for Royal Enfield bikes was the conversation for the next 10 minutes. He also remarks that all the male members of his family own one Royal Enfield bike.</p><br/>

<p>After what seems like an hour, I ask him whether we can stop for chai. He agrees and stops at a Road Side chai shop. "So, a chai person eh?" he asks.<br/>
I respond after sipping the hot tea, it's the best combination for the cold I am feeling against my skin.<br/>
"Hell yeah, in fact, I love coffee too. It depends on the situation though. But tea over coffee, any day," I say.<br/>
He responds by talking about his obsession with caffeine and that he would choose coffee over tea. Not just bikes, we have a lot of things in common.</p><br/>

<p>He lends me his jacket sensing that I am in cold. I silently thank myself for choosing to wear jeans today rather than a short dress or a skirt. We sit there for about 30 minutes talking and then resume our journey.</p><br/>

<p>He was indeed riding slowly all this while, maybe to keep up the conversation. Now he completely speeds up, halting our conversation.</p><br/>

<p>It has been around 3 hours since we left Church Street and I see a signboard telling 5km to Manchanabele Dam. Why haven't I noticed the signboards before? I curse myself for getting carried away in his presence and not at all worrying about where we were headed to.</p><br/>

<p>I then ask him whether we are headed to Manchanabele Dam, he laughs and replies, "Took you quite a while to figure that out."<br/>
I quickly respond, "Well, I've only been in Bangalore for a year more or less, and I'm not very familiar with places around here. In fact, I've never heard of this place before."<br/>
He replies, "This place is near the famous Savandurga Hills. You would have heard about that right?"<br/>
He glances at me from the rearview mirror and I nod.<br/>
He continues, "This place has a small trail that leads to the falls, it's really nice, you will love it."<br/>
It for sure sounds exciting. I instantly google the place, it just shows 1 hour from Church Street.</p><br/>

<p>Puzzled, I ask, "Why did it take us so long to get here? It's so close to Church Street."<br/>
Ayush responds, "The drive was pretty amazing, don't you think? You rarely get such empty roads around Bangalore during the daytime." I wholeheartedly agree.</p><br/>

<p>The next 20 minutes or so are spent navigating a congested trail, which even includes riding over water. There's hardly another soul in sight. Eventually, we reach the falls, spending about an hour there, chatting, and laughing. We witness the sunrise there too. After clicking a large number of pictures we head back.</p><br/>

<p>On our way back, the view of the dam looked mesmerizing from the roads. The drive back was more fun indeed.</p><br/>

<p>We head to Rameshwaram Cafe in JP Nagar for breakfast. It's there that we exchange our phone numbers before Ayush drops me back home.</p><br/>



</div>

   <h2 className="titles1-4">
Present<br/>
11:45 p.m 9th September 2023
</h2>
   <div className="description1-2">     
   <p>We arrive at the airport on time just to find out the flight gets delayed by an hour. We decide to snack a bit at the Chai Stop. We spot a couple there, talking about how hard it is to part. It was apparent that one of them was about to embark on a temporary journey to another city, leaving behind a bittersweet moment. Since they had the table next to us, we were able to hear everything they were conversing about.</p><br/>

<p>"Now, this is precisely why finding the right person is such a challenge. I mean, I'm not about to get all sentimental like that. Life demands practicality, doesn't it?" I whisper to Ayush.</p><br/>

<p>He replies, “You do know I’m too practical, right? Sometimes, people overlook what’s right in front of them.”

“Ayush, shut up. I’m really exhausted, I just wanna lie down,” I say.

He says, “Go and take a nap in the car, I’ll get him. But be careful.” I agree and head to the car.</p><br/>

<p>I hear a knock on the window and wake up startled. I immediately realize where I am and sit upright. I open the lock of the car and get down to greet his brother, Dev.</p><br/>

<p>No, no, no! What’s happening?</p><br/>

<p>This is not Dev; it is Daksh. I stand there, frozen in disbelief, uncertain what to do.</p><br/>

<p>Daksh extends his hand with a warm smile. "Hey, I'm Daksh, Ayush's brother. My family calls me Dev."</p><br/>

<p>Does he not remember me? Or is he pretending in front of his brother?

I feel it’s safe to pretend for now, and I introduce myself too. I hope that in case he has forgotten me, my introduction might jog his memory…</p><br/>

<p>To be continued...</p>

</div>
    <hr></hr>




          <Share/>
      </div>
</div> )}

export default Bumble;

 


